// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1jMlu","title":"ClientInsurance_title__2XNs3","itemText":"ClientInsurance_itemText__3c2fo"};